import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Button, Card } from "tabler-react";

const TelegramReverseConnect = ({ t, token, onSuccess, onError }) => {
    const [submitting, setSubmitting] = useState(false);
    const [tokenInfo, setTokenInfo] = useState(null);

    useEffect(() => {
        if (token) {
            // Decode token to show user info (for UX)
            try {
                const payload = JSON.parse(atob(token.split(".")[1]));
                setTokenInfo({
                    username: payload.username,
                    expires: new Date(payload.exp * 1000),
                });
            } catch (e) {
                console.warn("Could not decode token for display:", e);
            }
        }
    }, [token]);

    const handleConnect = async () => {
        setSubmitting(true);

        try {
            const response = await fetch("/d/api/telegram/reverse-link/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": window.csrf_token,
                },
                credentials: "same-origin",
                body: JSON.stringify({ token }),
            });

            const data = await response.json();

            if (response.ok) {
                if (onSuccess) onSuccess(data);
            } else {
                toast.error(data.error || "Unknown error");
                if (onError) onError(data);
            }
        } catch (error) {
            console.error("Error connecting telegram:", error);
            toast.error(t("shop.account.telegram.reverse_link_error"));
            if (onError) onError({ error: error.message });
        } finally {
            setSubmitting(false);
        }
    };

    if (!token) {
        return (
            <div className="alert alert-warning">
                {t("shop.account.telegram.no_token_provided")}
            </div>
        );
    }

    const isExpired = tokenInfo && new Date() > tokenInfo.expires;

    return (
        <Card>
            <Card.Header>
                <Card.Title>
                    📱 {t("shop.account.telegram.reverse_connect_title")}
                </Card.Title>
            </Card.Header>
            <Card.Body>
                {tokenInfo && (
                    <div className="mb-4">
                        <p className="text-muted">
                            {t("shop.account.telegram.reverse_connect_info")}
                        </p>
                        <div className="alert alert-info">
                            <strong>Telegram Username:</strong> @
                            {tokenInfo.username || "Unknown"}
                            <br />
                            <strong>Expires:</strong>{" "}
                            {tokenInfo.expires.toLocaleString()}
                        </div>
                    </div>
                )}

                {isExpired ? (
                    <div className="alert alert-danger">
                        {t("shop.account.telegram.token_expired")}
                    </div>
                ) : (
                    <div className="form-group">
                        <Button
                            color="primary"
                            onClick={handleConnect}
                            loading={submitting}
                            disabled={submitting}
                            className="btn-lg"
                        >
                            {t("shop.account.telegram.connect_account_button")}
                        </Button>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default withTranslation()(TelegramReverseConnect);
